import logoDynomo from '../assets/svg/logo.svg'
import techLogin from '../assets/svg/techlogin.svg'
import cat1 from '../assets/png/cat1.png'
import cat2 from '../assets/png/cat2.png'
import cat3 from '../assets/png/cat3.png'
import cat4 from '../assets/png/cat4.png'
import cat5 from '../assets/png/cat5.png'
import cat6 from '../assets/png/cat6.png'
import cat7 from '../assets/png/cat7.png'
import cat8 from '../assets/png/cat8.png'
import cat9 from '../assets/png/cat9.png'
import cat10 from '../assets/png/cat10.png'
import cat11 from '../assets/png/cat11.png'
import cat12 from '../assets/png/cat12.png'
import cat13 from '../assets/png/cat13.png'
import applelogo from '../assets/svg/apple.svg'
import google from '../assets/svg/Google.svg'
import eyeoff from '../assets/svg/Eyeoff.svg'
import eye from '../assets/svg/eye.svg'
import cat14 from '../assets/png/cat14.png'
import cat15 from '../assets/png/cat15.png'
import location from '../assets/svg/location.svg'
import menuicon from '../assets/svg/menuicon.svg'
import searchbar from '../assets/svg/searchbar.svg'
import favourite from '../assets/svg/favourite.svg'
import notification from '../assets/svg/notification.svg'
import avatarman from '../assets/svg/avatarman.svg'
import cart from '../assets/svg/cart.svg'
import arrowdown from '../assets/svg/arrow-down.svg'
import arrowleft from '../assets/svg/leftarrow.svg'
import arrowright from '../assets/svg/rightarrow.svg'
import logolight from '../assets/png/logolight.png'
import qrcode from '../assets/png/qrcode.png'
import appstore from '../assets/png/downloadappstore.png'
// import playstore from '../assets/png/downloadplaystore.png'
import facebook from '../assets/svg/Icon-Facebook.svg'
import linkedin from '../assets/svg/Icon-Linkedin.svg'
import instagram from '../assets/svg/icon-instagram.svg'
import twitter from '../assets/svg/icontwitter.svg'
import shoppingwomen from '../assets/png/shoppingwomen.png'
import product1 from '../assets/png/product1.png'
import product2 from '../assets/png/product2.png'
import product3 from '../assets/png/product3.png'
import product4 from '../assets/png/product4.png'
import item1 from '../assets/png/item1.png'
import item2 from '../assets/png/item2.png'
import item3 from '../assets/png/item3.png'
import item4 from '../assets/png/item4.png'
import item5 from '../assets/png/item5.png'
import newsLetter1 from '../assets/png/newsletter1.png'
import newsLetter2 from '../assets/png/newslettercoffee.png'
import clock from '../assets/svg/clock.svg'
import plus from '../assets/svg/Plus.svg'
import minus from '../assets/svg/Minus.svg'
import star from '../assets/svg/star.svg'
import user from '../assets/svg/reviewclient.svg'
import close from '../assets/png/close.png'
import location2 from '../assets/svg/locationwithbg.svg'
import shipping from '../assets/svg/Shipping.svg'
import payment from '../assets/svg/payment.svg'
import edit from '../assets/png/edit.png'
import pricing from '../assets/png/pricing.jpg'
import add from '../assets/svg/addlight.svg'
import visa from '../assets/svg/visa.svg'
import heart from '../assets/svg/Heart.svg'
import master_cart from '../assets/svg/master-card.svg'
import ideal from '../assets/svg/ideal.svg'
import mastercard from '../assets/svg/mastercard.svg'
import question from '../assets/svg/question.svg'
import chip from '../assets/png/chip.png'
import cardline from '../assets/svg/cardline.svg'
import arrowRight from '../assets/svg/arrowright.svg'
import aboutOffice from '../assets/png/aboutOffice.png'
import pluscircle from '../assets/svg/pluscircle.svg'
import wifi from '../assets/svg/wifi.svg'
import product5 from '../assets/png/product5.png'
import credit_card from '../assets/svg/credit_card.svg'
import ticket from '../assets/svg/Ticket.svg'
import company1 from '../assets/png/company1.png'
import company2 from '../assets/png/company2.png'
import company3 from '../assets/png/company3.png'
import company4 from '../assets/png/company4.png'
import homebg1 from '../assets/png/homebg1.webp'
import company5 from '../assets/png/company5.png'
import company6 from '../assets/png/company6.png'
import owner1 from '../assets/owner1.jpg'
import adminCal from '../assets/adminCal.png'
import owner2 from '../assets/owner3.jpg'
import teamlead1 from '../assets/place1.jpg'
import teamlead2 from '../assets/place2.jpg'
import teamlead3 from '../assets/place3.jpg'
import playstore from '../assets/png/playstore.png'
import apple from '../assets/png/apple.png'
import dynomobg1 from '../assets/png/dynomo1.png'
import dynomobg2 from '../assets/png/dyomo2.png'
import feature1 from '../assets/png/feature1.png'
import feature2 from '../assets/png/feature2.png'
import feature3 from '../assets/png/feature3.png'
import feature4 from '../assets/png/feature4.png'
import feature5 from '../assets/png/feature5.png'
import feature6 from '../assets/png/feature6.png'
import feature7 from '../assets/png/feature7.png'
import feature8 from '../assets/png/feature8.png'
import feature9 from '../assets/png/feature9.png'
import feature10 from '../assets/png/feature10.png'
import feature11 from '../assets/png/feature11.png'
import feature12 from '../assets/feature1.webp'
import svg1 from '../assets/svg/svg1.svg'
import feature14 from '../assets/png/merchantlogo.png'
import feature13 from '../assets/png/registerlogo.png'
import graph from '../assets/png/graph.png'
import featurenew from '../assets/featurenew.webp'
import dummy from '../assets/_img.svg'
import step1 from '../assets/step1.png'
import step2 from '../assets/step2.png'
import step3 from '../assets/step3.jpg'

const pricingData = [
    {
        title: 'Basic Plan',
        subTitle: `Perfect for online stores who want to
        market their products on Dynomo's
        platform`,
        list: [
            { check: 1, item: "Market Your Products On Dynomo", },
            { check: 1, item: "No Installation Required" },
            { check: 0, item: "No Automation" },
            { check: 0, item: "Limited Data Collection & Features" },
        ],
        monthly: 12,
        annual: 144
    },
    {
        title: 'Standard Plan',
        subTitle: `Perfect for customer-based stores like
        Brick-and-mortar stores, local events,
        bars, restaurants etc. who want to
        market their products on Dynomo's
        platform`,
        list: [
            { check: 1, item: "Market Your Products On Dynomo", },
            { check: 1, item: "Enjoy A1 Automation & Dynamic Pricing" },
            { check: 1, item: "Add up to 500 customer to your relations" },
            { check: 1, item: "Add up to 5 seats" },
            { check: 0, item: "Installation Required" },
        ],
        monthly: 50,
        annual: 600
    },
    {
        title: 'Local processing plan',
        subTitle: `Perfect for customer-based stores like
        Brick-and-mortar stores, local events,
        bars, restaurants etc. who want to
        market their pts on Dynomo's
        platform, with local data processing`,
        list: [
            { check: 1, item: "Market Your Products On Dynomo", },
            { check: 1, item: "Enjoy A1 Automation & Dynamic Pricing" },
            { check: 1, item: "Access To All Features Without limitations" },
            { check: 1, item: "Extra store security" },
            { check: 1, item: "Add Unlimited customer to your relations" },
            { check: 1, item: "Add Unlimited seats" },
            { check: 0, item: "Installation Required" },
        ],
        monthly: 75,
        annual: 900
    },
]
export {
    pricingData, step1, owner1, owner2, adminCal,
    feature13, feature14, graph, dummy, step3, step2,
    location, featurenew, arrowRight, pricing, svg1, dynomobg1, feature12, dynomobg2, feature1, feature10, feature11, feature2, feature3, feature4, feature5, feature6, feature7, feature8, feature9, apple, teamlead1, teamlead2, teamlead3, company6, homebg1, company5, company4, company3, company2, company1, aboutOffice, ticket, product5, pluscircle, eye, eyeoff, google, applelogo, heart, credit_card, question, cardline, chip, wifi, mastercard, master_cart, visa, ideal, edit, add, location2, payment, shipping, close, user, plus, star, minus, clock, newsLetter2, arrowleft, arrowright, item2, item1, newsLetter1, item3, item4, item5, product1, product2, product3, product4, qrcode, shoppingwomen, facebook, linkedin, instagram, twitter, appstore, playstore, logolight, searchbar, favourite, notification, avatarman, cart, arrowdown, menuicon, techLogin, logoDynomo, cat1, cat2, cat3, cat4, cat5, cat6, cat7, cat8, cat9, cat10, cat11, cat12, cat13, cat14, cat15
}